import type { ReactNode } from 'react';
import { CoinIcon } from '@/components/CurrencyIcon';

export interface ShopSaleInfo {
  discountPercent: number;
  label: string | null;
  startsAt: string | null;
  endsAt: string | null;
}

export interface SalePriceFields {
  originalPriceCoins: number | null;
  originalPriceGems: number | null;
  sale: ShopSaleInfo | null;
}

export function SaleBadge({ sale }: { sale: ShopSaleInfo | null | undefined }) {
  if (!sale) return null;
  return (
    <span
      className="display"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '3px 6px',
        borderRadius: 5,
        background: 'linear-gradient(135deg, #E63946, #ff6b35)',
        color: '#fff',
        fontSize: 8,
        letterSpacing: '.05em',
        boxShadow: '0 2px 8px rgba(230,57,70,.38)',
        whiteSpace: 'nowrap',
      }}
    >
      {sale.label?.trim() || `-${sale.discountPercent}%`}
    </span>
  );
}

export function SalePrice({
  price,
  original,
  currency,
  suffix,
}: {
  price: number;
  original: number | null | undefined;
  currency: 'coins' | 'gems';
  suffix?: ReactNode;
}) {
  const icon = currency === 'gems' ? '💎' : <CoinIcon size={13} />;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 5, flexWrap: 'wrap' }}>
      {original != null && original > price && (
        <span style={{ textDecoration: 'line-through', opacity: 0.55, fontSize: '.82em' }}>
          {original.toLocaleString()}
        </span>
      )}
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {price.toLocaleString()} {icon}
      </span>
      {suffix}
    </span>
  );
}
